import { useStore } from "zustand";
import { createWindowStore, type WindowStoreState } from "./windowStore";

/** Instancia única del WM para la app (los tests crean las suyas con la factory). */
export const windowStore = createWindowStore();

export function useWindowStore<T>(selector: (s: WindowStoreState) => T): T {
  return useStore(windowStore, selector);
}
